import { render } from "./group.vue?vue&type=template&id=8af2c416&scoped=true"
const script = {}

import "./group.vue?vue&type=style&index=0&id=8af2c416&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af2c416"]])

export default __exports__